export default {"src":"/_next/static/media/microwave.3a88cbde.svg","height":100,"width":100};